import React from "react"
import PortfolioTabs from "./PortfolioTabs";

 const portfolio =()=> <div className="container">
 <div className="portfolio">
<h1>Portfolio</h1>
<PortfolioTabs/>
</div>
 </div>
 
export default portfolio;
